import request from '@/axios'
/**
 * @Description: 获取已发布的软件信息
 */
export function selectSoftwareInPublish() {
    return request({
        method: 'get',
        url: '/api/software/selectSoftwareInPublish',
    })
}

/**
 * @Description: 下载软件
 */
export function downloadSoftware(id, username) {
    return request({
        method: 'get',
        url: '/api/software/downloadSoftware',
        params: {
            id,
            username
        }
    })
}